import { render, staticRenderFns } from "./OneWayLaw.vue?vue&type=template&id=5932275a&scoped=true"
import script from "./OneWayLaw.vue?vue&type=script&lang=js"
export * from "./OneWayLaw.vue?vue&type=script&lang=js"
import style0 from "./OneWayLaw.vue?vue&type=style&index=0&id=5932275a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932275a",
  null
  
)

export default component.exports